var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _DescribeAssetRequest_instances, _DescribeAssetRequest_assetCache, _DescribeAssetRequest_pendingRequestCache, _DescribeAssetRequest_client, _DescribeAssetRequest_createCommand, _DescribeAssetRequest_cacheAsset, _DescribeAssetRequest_cachePendingRequest, _DescribeAssetRequest_deletePendingRequest, _DescribeAssetRequest_handleError;
import { DescribeAssetCommand, } from '@aws-sdk/client-iotsitewise';
export class DescribeAssetRequest {
    constructor(client) {
        _DescribeAssetRequest_instances.add(this);
        _DescribeAssetRequest_assetCache.set(this, {});
        _DescribeAssetRequest_pendingRequestCache.set(this, {});
        _DescribeAssetRequest_client.set(this, void 0);
        __classPrivateFieldSet(this, _DescribeAssetRequest_client, client, "f");
    }
    async send(assetId) {
        const cachedAsset = __classPrivateFieldGet(this, _DescribeAssetRequest_assetCache, "f")[assetId];
        if (cachedAsset) {
            return cachedAsset;
        }
        const cachedRequest = __classPrivateFieldGet(this, _DescribeAssetRequest_pendingRequestCache, "f")[assetId];
        try {
            // If several requests for the same asset happen at the same time, we
            // prevent duplication of requests by reusing a cached pending promise.
            if (cachedRequest) {
                const asset = await cachedRequest;
                __classPrivateFieldGet(this, _DescribeAssetRequest_instances, "m", _DescribeAssetRequest_cacheAsset).call(this, assetId, asset);
                __classPrivateFieldGet(this, _DescribeAssetRequest_instances, "m", _DescribeAssetRequest_deletePendingRequest).call(this, assetId);
                return asset;
            }
            const command = __classPrivateFieldGet(this, _DescribeAssetRequest_instances, "m", _DescribeAssetRequest_createCommand).call(this, assetId);
            const request = __classPrivateFieldGet(this, _DescribeAssetRequest_client, "f").send(command);
            __classPrivateFieldGet(this, _DescribeAssetRequest_instances, "m", _DescribeAssetRequest_cachePendingRequest).call(this, assetId, request);
            const asset = await request;
            __classPrivateFieldGet(this, _DescribeAssetRequest_instances, "m", _DescribeAssetRequest_cacheAsset).call(this, assetId, asset);
            __classPrivateFieldGet(this, _DescribeAssetRequest_instances, "m", _DescribeAssetRequest_deletePendingRequest).call(this, assetId);
            return asset;
        }
        catch (error) {
            __classPrivateFieldGet(this, _DescribeAssetRequest_instances, "m", _DescribeAssetRequest_handleError).call(this, error);
        }
    }
}
_DescribeAssetRequest_assetCache = new WeakMap(), _DescribeAssetRequest_pendingRequestCache = new WeakMap(), _DescribeAssetRequest_client = new WeakMap(), _DescribeAssetRequest_instances = new WeakSet(), _DescribeAssetRequest_createCommand = function _DescribeAssetRequest_createCommand(assetId) {
    const command = new DescribeAssetCommand({ assetId });
    return command;
}, _DescribeAssetRequest_cacheAsset = function _DescribeAssetRequest_cacheAsset(assetId, asset) {
    __classPrivateFieldGet(this, _DescribeAssetRequest_assetCache, "f")[assetId] = asset;
}, _DescribeAssetRequest_cachePendingRequest = function _DescribeAssetRequest_cachePendingRequest(assetId, request) {
    __classPrivateFieldGet(this, _DescribeAssetRequest_pendingRequestCache, "f")[assetId] = request;
}, _DescribeAssetRequest_deletePendingRequest = function _DescribeAssetRequest_deletePendingRequest(assetId) {
    delete __classPrivateFieldGet(this, _DescribeAssetRequest_pendingRequestCache, "f")[assetId];
}, _DescribeAssetRequest_handleError = function _DescribeAssetRequest_handleError(error) {
    const errorMessage = `Failed to describe asset. Error: ${error}`;
    console.error(errorMessage);
    throw new Error(errorMessage);
};
